import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  GET_INVITATION_ONBOARDING_EMPLOYEE_LIST,
  GET_ONBOARDING_EMPLOYEES_NAME_LIST,
} from "../../config/Endpoints";
import Cookies from "js-cookie";
import { getApi } from "../../utils/api";
import AssignManager from "../AssignManager/AssignManager";
import SendEmployeeOnboarding from "./SendEmployeeOnboarding";
import { ThreeDots, TailSpin } from "react-loader-spinner";
import { displayFormatDate, toggleMenu } from "../../utils/helpers";
import Pagination from "../../components/Pagination";
import moment from "moment";
import Footer from "../../components/Footer";
import PageTitle from "../../components/PageTitle";
import Select from "react-select";
import SortableTable from "../../components/SortableTable";

const InvitationList = ({ title, description }) => {
  const [employeeList, setEmployeeList] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [isLoading, setisLoading] = useState(false);
  const [filteredItems, setFilteredItems] = useState();
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [isEmploeeOptionsLoading, setIsEmployeeOptionsLoading] =
    useState(false);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const accessToken = Cookies.get("accessToken");
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);

  const columns = [
    { key: "name", label: "Name" },
    { key: "email", label: "Email" },
    {
      key: "createdOn",
      label: "Invitation Date",
      render: (row) => displayFormatDate(row.createdOn),
    },
    { key: "status", label: "Status" },
  ];

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  const handleLimitChange = (e) => {
    setLimit(e.target.value);
    setCurrentPage(1);
  };

  const fetchEmployeeNames = async () => {
    setIsEmployeeOptionsLoading(true);
    try {
      const res = await getApi(GET_ONBOARDING_EMPLOYEES_NAME_LIST, accessToken);
      if (res.status === 200) {
        setEmployeeOptions(
          res.data.data.map((emp) => ({
            value: emp.id,
            label: emp.name,
          }))
        );
      }
      setIsEmployeeOptionsLoading(false);
    } catch (e) {
      setIsEmployeeOptionsLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployeeNames();
  }, []);

  useEffect(() => {
    fetchList();
  }, [currentPage, limit, selectedEmployeeId]);

  const fetchList = () => {
    setisLoading(true);

    const employeeParam = selectedEmployeeId ? `&id=${selectedEmployeeId}` : "";

    getApi(
      `${GET_INVITATION_ONBOARDING_EMPLOYEE_LIST}?status=pending${employeeParam}&page=${
        currentPage - 1
      }&pageSize=${limit}`,
      accessToken
    )
      .then((res) => {
        if (res.status === 200) {
          setEmployeeList(res.data.data.data);
          setFilteredItems(res.data.data.data);
          setTotalPages(res.data.data.totalPages);
          setTotalRecord(res.data.data.totalElements);
        }
        setisLoading(false);
      })
      .catch(() => setisLoading(false));
  };

  return (
    <div className="wrapper-body">
      {/* Page Heading */}

      {isEmploeeOptionsLoading && (
        <div className="overlay">
          <div className="mt-5">
            <TailSpin
              height="100"
              width="100"
              radius="1"
              color="blue"
              ariaLabel="tail-spin-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        </div>
      )}
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
        <div className="total">
          Total Employees : <span>{totalRecord}</span>
        </div>
      </div>

      {/* Filters */}
      <div className="filters">
        {/* <form action="index.html" id="form_filters" className="d-f"> */}
        {/* Search By Company */}

        <div className="col-md-5">
          <label className="label">Select Employee Name</label>

          <Select
            options={[...employeeOptions]}
            value={
              employeeOptions.find((opt) => opt.value === selectedEmployeeId) ||
              null
            }
            onChange={(selected) => {
              setSelectedEmployeeId(selected ? selected.value : null);
              setCurrentPage(1);
            }}
            isClearable
            placeholder="All"
          />
        </div>

        {/* <button type="submit" form="form_filters">
              Search
            </button> */}
        {/* </form> */}

        {/* Actions */}
        <div className="actions m-0">
          <Link
            className="export theme-button"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdropSend"
          >
            Invite Employee
          </Link>
        </div>
      </div>

      {/* Data Table */}
      {isLoading && !isEmploeeOptionsLoading && (
        <div className="centered-loader">
          <ThreeDots height="100" width="100" color="blue" />
        </div>
      )}
      {!isLoading && filteredItems?.length === 0 && (
        <div className="fs-4 text-secondary text-center">
          No Record Available
        </div>
      )}
      {!isLoading && filteredItems?.length > 0 && (
        <>
          <SortableTable
            columns={columns}
            data={employeeList}
            currentPage={currentPage}
            limit={limit}
          />
          {!selectedEmployeeId && (
            <div className="row">
              <div className="col-md-3">
                <label>Items per page</label>
                <select
                  onChange={handleLimitChange}
                  value={limit}
                  className="border ms-3 w-25 p-2"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={40}>40</option>
                </select>
              </div>

              <div className="col-md-9">
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          )}
        </>
      )}
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <AssignManager
              selectedEmployee={selectedEmployee}
              fetchList={fetchList}
              titleHeading="Employee Information"
              isEditable={false}
            />
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="staticBackdropSend"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <SendEmployeeOnboarding />
          </div>
        </div>
      </div>
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default InvitationList;
